const channels = [
  {
    id: 1,
    name: 'Hayley',
    url: 'https://www.youtube.com/channel/UCICrrLhBssTrUGoN0inpOwg',
    videos: [
      'https://www.youtube.com/watch?v=NOaDxVJVg9M',
      'https://www.youtube.com/watch?v=0t7H3-wTepc',
      'https://www.youtube.com/watch?v=QlG7Pd7a3Qs',
      'https://www.youtube.com/watch?v=-VQm4Hd5Pvo',
      'https://www.youtube.com/watch?v=pGGQ8Sz3PSE',
      'https://www.youtube.com/watch?v=LrrGa5swY3k'
    ],
    subscribers: 106000
  },
  {
    id: 2,
    name: 'Learn German',
    url: 'https://www.youtube.com/channel/UCaeT58uDMlPpBlwAYaxN0LA',
    videos: [
      'https://www.youtube.com/watch?v=b2feLAJX9gI',
      'https://www.youtube.com/watch?v=zNh1CmEP-B0',
      'https://www.youtube.com/watch?v=rk_EokULiT8',
      'https://www.youtube.com/watch?v=1lkE5F3BCx4',
      'https://www.youtube.com/watch?v=bZL5OB61XXM',
      'https://www.youtube.com/watch?v=PARun113NuA',
      'https://www.youtube.com/watch?v=WPDvdKaxa9g',
      'https://www.youtube.com/watch?v=BISRFfjDKfY',
      'https://www.youtube.com/watch?v=FUl6P7XDemc',
      'https://www.youtube.com/watch?v=15hmmpt15ag',
      'https://www.youtube.com/watch?v=HAunek7Ysek',
      'https://www.youtube.com/watch?v=IowuDehrLFk',
      'https://www.youtube.com/watch?v=UomeU3Ii9EY',
      'https://www.youtube.com/watch?v=07WCBZRchY0',
      'https://www.youtube.com/watch?v=HCytWm3RC9g',
      'https://www.youtube.com/watch?v=m7WOGlt0F2o',
      'https://www.youtube.com/watch?v=2QvDHCKm5J8',
      'https://www.youtube.com/watch?v=hWIS9QmvjqE',
      'https://www.youtube.com/watch?v=mjwiO46u8T8',
      'https://www.youtube.com/watch?v=xy4a1c7W7k0',
      'https://www.youtube.com/watch?v=YhupfAAAJk4',
      'https://www.youtube.com/watch?v=N3M3TN3fOI4',
      'https://www.youtube.com/watch?v=8JaSPVkYOhk',
      'https://www.youtube.com/watch?v=YYIRgl9lBu0',
      'https://www.youtube.com/watch?v=hY4lHC6YZuQ',
      'https://www.youtube.com/watch?v=O87D3v8DI4Y',
      'https://www.youtube.com/watch?v=nfEyrNtnYqM',
      'https://www.youtube.com/watch?v=ZNc0y2Dy5N8',
      'https://www.youtube.com/watch?v=rre0wOzteeM',
      'https://www.youtube.com/watch?v=VrZcSSoIv6g',
      'https://www.youtube.com/watch?v=lhLevSjx8HY',
      'https://www.youtube.com/watch?v=n6db5VSUm2o',
      'https://www.youtube.com/watch?v=sOmgaY32ibQ',
      'https://www.youtube.com/watch?v=jVGnSYo_aMQ',
      'https://www.youtube.com/watch?v=UzJu2AC4RqI',
      'https://www.youtube.com/watch?v=iWyOKwIf_94',
      'https://www.youtube.com/watch?v=L6-_QPfxG2A',
      'https://www.youtube.com/watch?v=oHFBp-iVLNk',
      'https://www.youtube.com/watch?v=KDkQOXcEr4o',
      'https://www.youtube.com/watch?v=acbGDIEbxxE',
      'https://www.youtube.com/watch?v=oK08_6bfjWc',
      'https://www.youtube.com/watch?v=IKtbZlwULp0',
      'https://www.youtube.com/watch?v=TqP9t1I0xLw',
      'https://www.youtube.com/watch?v=xLa48zQ6ysY',
      'https://www.youtube.com/watch?v=RElBVZ1Wke0',
      'https://www.youtube.com/watch?v=S1rzbEyQa0E',
      'https://www.youtube.com/watch?v=8EkbWhFas6s',
      'https://www.youtube.com/watch?v=lOPyBOraL5c',
      'https://www.youtube.com/watch?v=1agjSgeiXRM',
      'https://www.youtube.com/watch?v=ek-V7EuVh8E',
      'https://www.youtube.com/watch?v=IaerX0Y6wmE',
      'https://www.youtube.com/watch?v=p8nJSKWnmxY',
      'https://www.youtube.com/watch?v=i2jjefZ5hCQ',
      'https://www.youtube.com/watch?v=dpmJwjaGv88',
      'https://www.youtube.com/watch?v=kNea1LgjJF0',
      'https://www.youtube.com/watch?v=d54ioeKA-jc',
      'https://www.youtube.com/watch?v=WymnB1V-gW8',
      'https://www.youtube.com/watch?v=ueeMAVO7ZcU',
      'https://www.youtube.com/watch?v=S8ukFF6SdGk'
    ]
  },
  {
    id: 3,
    name: 'Easy German: Learn German From the Streets!',
    url: 'https://www.youtube.com/channel/UCbxb2fqe9oNgglAoYqsYOtQ',
    videos: [
      'https://www.youtube.com/watch?v=xvqPIUXCUQo',
      'https://www.youtube.com/watch?v=Hjiy_ogekcw',
      'https://www.youtube.com/watch?v=ffYy_nNxbPg',
      'https://www.youtube.com/watch?v=f9cc3VnoRGY',
      'https://www.youtube.com/watch?v=fqtA8nASKRs',
      'https://www.youtube.com/watch?v=B9EJ_x-RSuY',
      'https://www.youtube.com/watch?v=4vriPwOPpSg',
      'https://www.youtube.com/watch?v=kQPvtHeUUfU',
      'https://www.youtube.com/watch?v=UiFIzW8d5LI',
      'https://www.youtube.com/watch?v=F0N6RJEAus0',
      'https://www.youtube.com/watch?v=hAkxKMlYUI4',
      'https://www.youtube.com/watch?v=wkNqVUb0VUc',
      'https://www.youtube.com/watch?v=YsfPMPzxCVI'
    ]
  },
  {
    id: 4,
    name: 'German with Laura',
    url: 'https://www.youtube.com/channel/UCkMHiPVq_Zl55BeBofIhXog',
    videos: [
      'https://www.youtube.com/watch?v=1XdroGLSbZ4',
      'https://www.youtube.com/watch?v=y9TuL_SC6n4',
      'https://www.youtube.com/watch?v=_eJtobk_ojY',
      'https://www.youtube.com/watch?v=6K70nyv-Nm4',
      'https://www.youtube.com/watch?v=kw1SBeItMqQ',
      'https://www.youtube.com/watch?v=OVqxGMl75vY',
      'https://www.youtube.com/watch?v=9cRS_S0dOGU',
      'https://www.youtube.com/watch?v=gBmtBWxR6A0',
      'https://www.youtube.com/watch?v=oxMdA7ITZtg',
      'https://www.youtube.com/watch?v=PtBlpxBR1tc',
      'https://www.youtube.com/watch?v=R0sI_FEXxkI',
      'https://www.youtube.com/watch?v=aDHP9b_ldhc',
      'https://www.youtube.com/watch?v=ieiTMgVDPl4',
      'https://www.youtube.com/watch?v=KgTanflnQMY',
      'https://www.youtube.com/watch?v=o48q5g2HSWE',
      'https://www.youtube.com/watch?v=x6gSAkM0E8c',
      'https://www.youtube.com/watch?v=fo8D6drR_7c',
      'https://www.youtube.com/watch?v=ymIupVfH5FQ',
      'https://www.youtube.com/watch?v=ETgzwmkhsLc',
      'https://www.youtube.com/watch?v=PiyRRb14LRc',
      'https://www.youtube.com/watch?v=IBDAE820OZs',
      'https://www.youtube.com/watch?v=PsnXkUeITTM',
      'https://www.youtube.com/watch?v=KalxOq8TEM0',
      'https://www.youtube.com/watch?v=Jh9XZzrERTQ',
      'https://www.youtube.com/watch?v=ZFCXCD9j2Kc',
      'https://www.youtube.com/watch?v=FGggmauu0og',
      'https://www.youtube.com/watch?v=dVQZH-yg1BU',
      'https://www.youtube.com/watch?v=paDNTjoWExI'
    ]
  },
  {
    id: 5,
    name: 'German Online Gym',
    url: 'https://www.youtube.com/channel/UCVe51k2mKAYufKpEMuYAumQ',
    videos: [
      'https://www.youtube.com/watch?v=G470smAuEKY',
      'https://www.youtube.com/watch?v=3n0zi6LhE5c',
      'https://www.youtube.com/watch?v=J8i69Om4THE',
      'https://www.youtube.com/watch?v=0dfG_SM0q3Y',
      'https://www.youtube.com/watch?v=0ku1Q_27fcI',
      'https://www.youtube.com/watch?v=x3q4LMs5zsY',
      'https://www.youtube.com/watch?v=RPHe6CD7qMI',
      'https://www.youtube.com/watch?v=jYN7OsFJlwo',
      'https://www.youtube.com/watch?v=uyJNFLQKdnA',
      'https://www.youtube.com/watch?v=Pnf3eUVNOsE',
      'https://www.youtube.com/watch?v=_LryPy_EOZQ',
      'https://www.youtube.com/watch?v=xEALHwrBIzo',
      'https://www.youtube.com/watch?v=JcpM1XT7ldE',
      'https://www.youtube.com/watch?v=KVXxfMotr8E',
      'https://www.youtube.com/watch?v=2W-QpT3Jzh4',
      'https://www.youtube.com/watch?v=5C0-1f_geKc',
      'https://www.youtube.com/watch?v=Dt8LvqOGR0c',
      'https://www.youtube.com/watch?v=p9cu3LcUGHc',
      'https://www.youtube.com/watch?v=KKqACuUbWWQ',
      'https://www.youtube.com/watch?v=79m71dQ-ybw',
      'https://www.youtube.com/watch?v=p0fs0JNH2u4',
      'https://www.youtube.com/watch?v=LAbSHjWbDZM',
      'https://www.youtube.com/watch?v=cXiYv4gXhCY',
      'https://www.youtube.com/watch?v=HwB9lePiJuE',
      'https://www.youtube.com/watch?v=RmDKGNbv8k8',
      'https://www.youtube.com/watch?v=qihFkBjwuxk',
      'https://www.youtube.com/watch?v=Dg4ru3zvkCY',
      'https://www.youtube.com/watch?v=sGhMIk9lejc',
      'https://www.youtube.com/watch?v=FCW9dduQUFw',
      'https://www.youtube.com/watch?v=o5lV62skuJ4',
      'https://www.youtube.com/watch?v=FW380TVpCGA',
      'https://www.youtube.com/watch?v=1a-3g6zAI1Q',
      'https://www.youtube.com/watch?v=THJ-GUqU-UI',
      'https://www.youtube.com/watch?v=6Qw-OqpK9gs',
      'https://www.youtube.com/watch?v=AmYzNcsQvlY',
      'https://www.youtube.com/watch?v=s-OTC2qaslA',
      'https://www.youtube.com/watch?v=su9nzXv-Z0g',
      'https://www.youtube.com/watch?v=w5aKnWGyq5A',
      'https://www.youtube.com/watch?v=QJ7Il0Jlh3g',
      'https://www.youtube.com/watch?v=6zDnTy94eeo'
    ]
  },
  {
    id: 6,
    name: 'Learn German with GermanPod101.com',
    url: 'https://www.youtube.com/channel/UCTobWZV_HWGSoaRrhHyrJ-A',
    videos: [
      'https://www.youtube.com/watch?v=e66Ij24rZRo',
      'https://www.youtube.com/watch?v=5g6358iw0Ho',
      'https://www.youtube.com/watch?v=fMp-bNTx9Xo',
      'https://www.youtube.com/watch?v=CbAwW4FG6IE',
      'https://www.youtube.com/watch?v=O7lyYNXe-zY',
      'https://www.youtube.com/watch?v=dC99TApoFGo',
      'https://www.youtube.com/watch?v=nhnpfYPtrtU',
      'https://www.youtube.com/watch?v=pr2BIUUrJto',
      'https://www.youtube.com/watch?v=gL_6FPIKyws',
      'https://www.youtube.com/watch?v=LKCHhdFYH-I',
      'https://www.youtube.com/watch?v=qpNn5efWYOs',
      'https://www.youtube.com/watch?v=dCYgLyb5TVI',
      'https://www.youtube.com/watch?v=dX1W2i_1k0s',
      'https://www.youtube.com/watch?v=XN8LH-427uU',
      'https://www.youtube.com/watch?v=7WbbD6hBnQc',
      'https://www.youtube.com/watch?v=hYS1oTN271g',
      'https://www.youtube.com/watch?v=7INuCpfigfY',
      'https://www.youtube.com/watch?v=XlTMaiQUuXE',
      'https://www.youtube.com/watch?v=s68urZZRScA',
      'https://www.youtube.com/watch?v=_N4Z28Pz1kA',
      'https://www.youtube.com/watch?v=pqGshn-iSjk',
      'https://www.youtube.com/watch?v=cPpjl9WC1YE',
      'https://www.youtube.com/watch?v=2F86EnTD7-I',
      'https://www.youtube.com/watch?v=xvsLSLTNoto',
      'https://www.youtube.com/watch?v=qMKlc_ojeO8',
      'https://www.youtube.com/watch?v=kUdWFQhSn_Q',
      'https://www.youtube.com/watch?v=50RWGxk-2UE',
      'https://www.youtube.com/watch?v=60tJI-RZhVU',
      'https://www.youtube.com/watch?v=4MKWGQi-mto',
      'https://www.youtube.com/watch?v=CZxci9E8pgM',
      'https://www.youtube.com/watch?v=XfZFDg028RE',
      'https://www.youtube.com/watch?v=AkU_98zMf78',
      'https://www.youtube.com/watch?v=u2V0ZV1B4z0',
      'https://www.youtube.com/watch?v=goePfBc7rYk',
      'https://www.youtube.com/watch?v=K7hsWQggtzI',
      'https://www.youtube.com/watch?v=Tt8TddRP1_s',
      'https://www.youtube.com/watch?v=8i_-poTRZNk',
      'https://www.youtube.com/watch?v=mseb6U-qX-U',
      'https://www.youtube.com/watch?v=X7eqr5P3coo',
      'https://www.youtube.com/watch?v=gxwnT1f6t68',
      'https://www.youtube.com/watch?v=FOBDhMEz7Go',
      'https://www.youtube.com/watch?v=yDvW8357yU8',
      'https://www.youtube.com/watch?v=-3gU3LRnGuQ',
      'https://www.youtube.com/watch?v=PVuUJ4EDilw',
      'https://www.youtube.com/watch?v=ZFNKiqKoRlw',
      'https://www.youtube.com/watch?v=iO8iNdVJ1hQ',
      'https://www.youtube.com/watch?v=TR8WhmPOULk',
      'https://www.youtube.com/watch?v=ZFW9lWqH-dM',
      'https://www.youtube.com/watch?v=EZF5gCrElRU',
      'https://www.youtube.com/watch?v=vOQ0XKvU4Bg',
      'https://www.youtube.com/watch?v=DOqtwutWzU8',
      'https://www.youtube.com/watch?v=uka7niYTz64',
      'https://www.youtube.com/watch?v=I3ngGh1jNQM',
      'https://www.youtube.com/watch?v=9Er9rhVkPbg',
      'https://www.youtube.com/watch?v=Dq7ahEFetcI',
      'https://www.youtube.com/watch?v=C_7ChR_nQaM',
      'https://www.youtube.com/watch?v=Vro0ZIsbNUs',
      'https://www.youtube.com/watch?v=mzv3Arvo9HU',
      'https://www.youtube.com/watch?v=fgEqX2mAnZI',
      'https://www.youtube.com/watch?v=WMu5iPYvdjo'
    ]
  },
  {
    id: 7,
    name: 'Learn German with Anja',
    url: 'https://www.youtube.com/c/LearnGermanwithAnja/featured',
    videos: [
      'https://www.youtube.com/watch?v=yu9irqGBvn8',
      'https://www.youtube.com/watch?v=D6sLldGCGic',
      'https://www.youtube.com/watch?v=0YeaDRTD56M',
      'https://www.youtube.com/watch?v=AUKYFqgU9fg',
      'https://www.youtube.com/watch?v=qokUFvV4pjM',
      'https://www.youtube.com/watch?v=vrkKAi8n70o',
      'https://www.youtube.com/watch?v=_8wc_KvNfOU',
      'https://www.youtube.com/watch?v=7721_5XPfH8',
      'https://www.youtube.com/watch?v=_-Z8pyQqDZI',
      'https://www.youtube.com/watch?v=5rEDFhnlBv0',
      'https://www.youtube.com/watch?v=5xnAfUb0g7Q',
      'https://www.youtube.com/watch?v=CBx8I0BNggw',
      'https://www.youtube.com/watch?v=hPJ2_xggUiA',
      'https://www.youtube.com/watch?v=4MPWmN5cauU',
      'https://www.youtube.com/watch?v=AWD408NOre0',
      'https://www.youtube.com/watch?v=9RXYXz4B8pY',
      'https://www.youtube.com/watch?v=vqFX-eQLE9o',
      'https://www.youtube.com/watch?v=Z6AOuAkjAvU',
      'https://www.youtube.com/watch?v=DL80Fl7Vu44',
      'https://www.youtube.com/watch?v=DzufI60ppp4',
      'https://www.youtube.com/watch?v=BaCW3QzHt8A',
      'https://www.youtube.com/watch?v=A6ZfZspk4ZY',
      'https://www.youtube.com/watch?v=YWrrm0FjY2A',
      'https://www.youtube.com/watch?v=OenY9WNgRYU',
      'https://www.youtube.com/watch?v=_kV0KU4_3Xw',
      'https://www.youtube.com/watch?v=SYG_i7rKl_4',
      'https://www.youtube.com/watch?v=73jRErmONCI',
      'https://www.youtube.com/watch?v=2agy8AwoC50',
      'https://www.youtube.com/watch?v=PdtS-1Lcd-c',
      'https://www.youtube.com/watch?v=SgkeIogKDVM',
      'https://www.youtube.com/watch?v=QSmKKg6PKB0',
      'https://www.youtube.com/watch?v=Se54fFZCRDQ',
      'https://www.youtube.com/watch?v=6OJ4bTMuqyY',
      'https://www.youtube.com/watch?v=fIr_pkqb8lU',
      'https://www.youtube.com/watch?v=20Kj-8zcouM',
      'https://www.youtube.com/watch?v=-AS8bbPTBWY',
      'https://www.youtube.com/watch?v=Dmv2BzXv_7U',
      'https://www.youtube.com/watch?v=5D2lz7rm-ZE',
      'https://www.youtube.com/watch?v=8oKwzqHeeN8',
      'https://www.youtube.com/watch?v=ErkAEDXPdhw',
      'https://www.youtube.com/watch?v=H0_2KrX98VA',
      'https://www.youtube.com/watch?v=q6Fzd75ONUA',
      'https://www.youtube.com/watch?v=yyQrh663e6I',
      'https://www.youtube.com/watch?v=YLZiHjLxOTs',
      'https://www.youtube.com/watch?v=QrFREY3vlow',
      'https://www.youtube.com/watch?v=qxApHPCW9mQ',
      'https://www.youtube.com/watch?v=1xYlWmPJmbA',
      'https://www.youtube.com/watch?v=r7Yg_r7Ep5Y',
      'https://www.youtube.com/watch?v=8wtEGy7AmZU',
      'https://www.youtube.com/watch?v=c4xNb7Lc9_0',
      'https://www.youtube.com/watch?v=Px9m51Pi3yM',
      'https://www.youtube.com/watch?v=_rIvRPaDH8o',
      'https://www.youtube.com/watch?v=grX8_4rUi2w',
      'https://www.youtube.com/watch?v=SifqNCsoQS8',
      'https://www.youtube.com/watch?v=kW4C3HTKJuM',
      'https://www.youtube.com/watch?v=wlgdMQHaL4U',
      'https://www.youtube.com/watch?v=IIddbPr5cKE',
      'https://www.youtube.com/watch?v=nB2uOlCkRE4',
      'https://www.youtube.com/watch?v=V9WNhHEkrkU',
      'https://www.youtube.com/watch?v=GS-cUunRw4s'
    ]
  },
  {
    id: 8,
    name: 'Get Germanized',
    email: '',
    url: 'https://www.youtube.com/@GetGermanized',
    videos: [
      'https://www.youtube.com/watch?v=t4ut7MdmvCo',
      'https://www.youtube.com/watch?v=hZEOM8jVxCA',
      'https://www.youtube.com/watch?v=JWmcfN6K3Dg'
    ]
  },
  {
    id: 9,
    name: 'Authentic German Learning',
    email: '',
    url: 'https://www.youtube.com/channel/UCcNBwmeFr0IeLVlP_49glrA',
    videos: [
      'https://www.youtube.com/watch?v=AL6vqs8OkT4',
      'https://www.youtube.com/watch?v=Kz45j-Erzz0'
    ],
    profileLinks: [
      {
        'label': 'Visit the site and learn more!',
        'url': 'https://authenticgermanlearning.com/'
      },
      {
        'label': 'Follow me on Twitter',
        'url': 'https://x.com/AuthGerLearning'
      },
      {
        'label': 'Paypal Donations',
        'url': 'https://www.paypal.com/paypalme/AuthenticGerman'
      }
    ]
  },
  {
    id: 10,
    name: 'Deutsch für Euch',
    email: '',
    url: 'https://www.youtube.com/c/DeutschFuerEuch',
    videos: [
      'https://www.youtube.com/watch?v=VkcmiPEW2EU'
    ]
  },
  {
    id: 11,
    name: 'SmarterGerman',
    email: '',
    url: 'https://www.youtube.com/c/smarterGermanBerlin',
    videos: [
      'https://www.youtube.com/watch?v=sRW-j_OY8kI'
    ]
  },
  {
    id: 12,
    name: 'YourGermanTeacher',
    email: '',
    url: 'https://www.youtube.com/c/YourGermanTeacher',
    videos: [
      'https://www.youtube.com/watch?v=Rd7HUf1x_WI'
    ]
  },
  {
    id: 13,
    name: 'Learn German with Herr Antrim',
    email: '',
    url: 'https://www.youtube.com/c/MrLAntrim',
    videos: [
      'https://www.youtube.com/watch?v=7ZCF2DOyUMQ'
    ],
    profileLinks: [
      {
        'label': 'FREE German Resources Guide',
        'url': 'https://www.germanwithantrim.com/'
      },
      {
        'label': 'German Books by Herr Antrim',
        'url': 'https://www.germanwithantrim.com/product-category/books/'
      },
      {
        'label': 'Books for German Learners',
        'url': 'https://www.amazon.com/shop/learngermanwithherrantrim'
      }
    ]
  },
  {
    id: 14,
    name: 'BookBox German',
    email: '',
    url: 'https://www.youtube.com/channel/UCHEzhKyjlp60u0Kgqc_ikNA',
    videos: [
      'https://www.youtube.com/watch?v=ZufhEMTwwrw'
    ]
  },
  {
    id: 15,
    name: 'lingoni GERMAN',
    email: '',
    url: 'https://www.youtube.com/@lingoniGERMAN',
    videos: [
      'https://www.youtube.com/watch?v=AYNn7v1Defk',
      'https://www.youtube.com/watch?v=9Bvt8AA4d-Y',
      'https://www.youtube.com/watch?v=i7Fi_LGSAIE'
    ],
    profileLinks: [
      {
        'label': 'Our app',
        'url': 'https://lingoni.com/german/'
      },
      {
        'label': 'TikTok',
        'url': 'https://www.tiktok.com/@lingonigerman'
      }
    ]
  }
]

export default channels


// WEBPACK FOOTER //
// ./src/browser/channels/languages/german.js